import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'

const WorkspaceFormDuration = ({ duration, onChange, formId }) => (
  <WorkspaceFormInput attribute='duration' formId={formId}>
    <input
      type='number'
      className='workspace-form__input'
      value={duration || ''}
      onChange={(e) => onChange({ duration: e.target.value ? Number(e.target.value) : null })}
    />
  </WorkspaceFormInput>
)

WorkspaceFormDuration.propTypes = {
  duration: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  formId: PropTypes.string
}

const mapStateToProps = state => ({
  duration: state.form.data.duration
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChange: data => dispatch(changeFormData(data, ownProps.formId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormDuration)
